<template>
  <div>
    <h2>Sign In</h2>
    <p>
      If you have shopped with us before, please enter your details in the boxes below. If you are a new customer please proceed to the Billing &amp; Shipping section.
    </p>
    <form @submit.prevent="submit" class="login-form inputs-border inputs-bg" novalidate> <!--ANGULAR-->
      <div class="form-group">
        <input type="text" id="username" ref="email" v-model="email" required class="form-control">
        <label for="username">Username or email*</label>
      </div>
      <div class="form-group">
        <input type="password" id="password" v-model="password" required class="form-control">
        <label for="password">Password*</label>
      </div>
      <!--<div class="form-group">
        <input type="checkbox" id="rememberme">
        <label for="rememberme" class="checkbox">Remember me</label>
        <a href="#!" class="effect pull-right">Forgot your password?</a>
      </div>-->
      <div class="form-group text-right">
          <div class="error" v-if="loginError">{{loginError.toString()}}</div>
          <button type="submit" class="btn btn-default signin-submit" id="button" :disabled="loginBusy">
            <span v-if="loginBusy">Signing In...</span>
            <span v-else>Sign In</span>
          </button>
      </div>
    </form>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  data() {
    return {
      email: '',
      password: '',
    }
  },
  computed: {
    ...mapGetters(['loginBusy', 'loginError'])
  },
  methods: {
    ...mapActions(['login']),
    submit() {
      this.login({username: this.email, password: this.password});
    }
  },
  mounted() {
    console.log('focusing');
    this.$refs.email.focus();
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/checkout/ReturningCustomerLogin.vue